import React, { useContext,useEffect, useState, useRef } from 'react';
import { ReactSession } from "react-client-session";
import { ContextGloball } from '../Context/ContextGlobal';
import {guardarErrorAsistencia, enviarErroresPendientes, activarDiagnosticosJavaScript} from "../Utils/diagnosticoAsistencia";

export default function Principal() {

  const { setLoading } = useContext(ContextGloball);
  const [hora, setHora] = useState(new Date());
  const [modo, setModo] = useState("principal"); 
  const [tipoMarca, setTipoMarca] = useState(""); 
  const [sucursalesCalculadas, setSucursalesCalculadas] = useState([]);
  const [mensajeError, setMensajeError] = useState(""); 
  const [desfase, setDesfase] = useState(0); 
  const [sucursalesBase, setSucursalesBase] = useState([]); 
  const [ubicacionActual, setUbicacionActual] = useState(null); 
  const [precisionGPS, setPrecisionGPS] = useState(null);
  const [esUbicacionAproximada, setEsUbicacionAproximada] = useState(false); 
  const [cargando, setCargando] = useState(true);
  const [mostrarDialogo, setMostrarDialogo] = useState(false);
  const [textoDialogo, setTextoDialogo] = useState("");
  const [resolverDialogo, setResolverDialogo] = useState(null);
  const [mostrarCodigo, setMostrarCodigo] = useState(false);
  const [codigoConfirmacion, setCodigoConfirmacion] = useState("");
  const [procesoMarcacion, setProcesoMarcacion] = useState(null);
  const [intentos,setIntentos] = useState(3);
  const [insertarObservacion, setInsertarObservacion] = useState(false);
  const [observacionSalidaAntipada, setObservacionSalidaAnticipada] = useState("");

  
  const [destinoConfigurado, setDestinoConfigurado] = useState(false);
  const [siguienteDestino, setSiguienteDestino] = useState(null);
  const [destinoSeleccionado, setDestinoSeleccionado] = useState("");
  const [mostrarDestino, setMostrarDestino] = useState(false);

  const [sucursalDestinoSeleccionada, setSucursalDestinoSeleccionada] = useState("");


  const [confirmandoMarcacion, setConfirmandoMarcacion] = useState(false);
  const confirmandoRef = useRef(false);
  
  const server = process.env.REACT_APP_SERVER;

  // 1. SINCRONIZACIÓN INICIAL (Hora y Sucursales)
  useEffect(() => {
    const inicializarApp = async () => {
      setLoading(true);
      try {
        await Promise.all([sincronizarReloj(), cargarSucursales()]);
      } catch (error) {
        console.error("Error en la carga inicial:", error);
      } finally {
        setLoading(false);
      }
    };
    inicializarApp();
  }, []);

  const sincronizarReloj = async () => {
    try {
      const response = await fetch(`${server}/api/asistencia/obtener-hora`);
      const data = await response.json();
      const ahoraLocal = Date.now();
      const diferencia = data.serverTime - ahoraLocal;
      setDesfase(diferencia);
    } catch (error) {
      console.error("Error sincronizando reloj:", error);
    }
  };

  const cargarSucursales = async () => {
    try {
      const regional = Number(JSON.parse(localStorage.getItem("info")).ID_REGIONAL_ACTUAL);
      const response = await fetch(`${server}/sqlComun/getSucursalesParaMarcar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ regional })
      });
      const data = await response.json();
      if (data.ok) {
        const mapeadas = data.data
          .filter(s => (s.GEO_LATITUD && s.GEO_LONGITUD && parseFloat(s.GEO_LATITUD) !== 0) || s.TIPO === 'EX')
          .map(s => ({
            id: s.ID_SUCURSAL,
            nombre: s.SUCURSAL,
            servidor: s.IP_SERVIDOR,
            lat: s.TIPO === 'EX' ? null : parseFloat(s.GEO_LATITUD),
            lng: s.TIPO === 'EX' ? null : parseFloat(s.GEO_LONGITUD),
            tipo: s.TIPO
          }));
        setSucursalesBase(mapeadas);
      }
    } catch (error) {
      setMensajeError("Error al cargar sucursales.");
    }
  };

  // 2. RELOJ SEGUNDERO SINCRONIZADO
  useEffect(() => {
    const timer = setInterval(() => {
      setHora(new Date(Date.now() + desfase));
    }, 1000);
    return () => clearInterval(timer);
  }, [desfase]);

  // 3. SEGUIMIENTO DE GPS (Con detección de precisión y ubicación aproximada)
  useEffect(() => {
    let watchId = null;
    if (modo === "sucursales") {
      setUbicacionActual(null);
      setPrecisionGPS(null);
      setEsUbicacionAproximada(false);

      if (process.env.REACT_APP_GEO_DUMMY === "S") {
          setUbicacionActual({
              lat: -17.378866412609625,
              lng: -66.15930441407112,
              accuracy: 5
          });

          setPrecisionGPS(5);
          setMensajeError("");
      } else {
        if (!navigator.geolocation) {
          setMensajeError("GPS no soportado en este dispositivo/navegador.");
          return;
        }  
        watchId = navigator.geolocation.watchPosition(
          (pos) => {
            const accuracy = pos.coords.accuracy;
            setPrecisionGPS(accuracy);

            // Si la precisión es de 1000 metros o más, se trata de modo Aproximado de Android/iOS
            if (accuracy >= 1000) {
              setEsUbicacionAproximada(true);
              setUbicacionActual(null);
              setMensajeError("⚠️ Ubicación aproximada detectada. Para marcar debes habilitar 'Ubicación precisa' en los permisos de tu navegador.");
              return;
            }

            setEsUbicacionAproximada(false);

            // Actualizar ubicación con la precisión obtenida
            setUbicacionActual({
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
              accuracy: accuracy
            });

            if (accuracy > 60) {
              setMensajeError(`📡 Señal GPS estabilizándose (precisión actual: ±${Math.round(accuracy)}m). Espera unos segundos...`);
            } else {
              setMensajeError("");
            }
          },
          (err) => {
            if (err.code === 1) {
              setMensajeError("Permiso de ubicación denegado. Concede permiso al navegador.");
            } else if (err.code === 2) {
              setMensajeError("Señal de GPS no disponible. Activa la ubicación en tu teléfono.");
            } else if (err.code === 3) {
              setMensajeError("Tiempo de espera del GPS agotado. Reintentando...");
            } else {
              setMensajeError("Activa el GPS para poder marcar.");
            }
          },
          { enableHighAccuracy: true, timeout: 20000, maximumAge: 0 }
        );
      }
    }
    return () => { if (watchId !== null) navigator.geolocation.clearWatch(watchId); };
  }, [modo]);

  // 4. CÁLCULO DE DISTANCIAS (Se dispara solo si cambia la ubicación)
  useEffect(() => {
    if (!ubicacionActual || sucursalesBase.length === 0) return;

    const actualizadas = sucursalesBase.map((suc) => {
        
      // Las sucursales externas no tienen coordenadas,
        // por lo tanto siempre están disponibles.
        if (suc.tipo === "EX") {
          return {
            ...suc,
            distanciaTexto: "Externo",
            estaCerca: true,
            esExterna: true
          };
        }

      const dist = calcularDistancia(ubicacionActual.lat, ubicacionActual.lng, suc.lat, suc.lng);
      return {
        ...suc,
        distanciaTexto: dist > 1000 ? `${(dist / 1000).toFixed(1)} km.` : `${Math.round(dist)} m.`,
        estaCerca: dist <= 30 && (ubicacionActual.accuracy == null || ubicacionActual.accuracy <= 60), // Margen de 30m y precisión adecuada
      };
    });
    setSucursalesCalculadas(actualizadas);
  }, [ubicacionActual, sucursalesBase]);

  const calcularDistancia = (lat1, lon1, lat2, lon2) => {
    if (!lat1 || !lon1 || !lat2 || !lon2) return Infinity;
    const R = 6371000;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) *
              Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

const pedirTexto = () => {
    return new Promise((resolve) => {
        setResolverDialogo(() => resolve);
        setTextoDialogo("");
        setMostrarDialogo(true);
    });
};

const obtenerRegionalDiagnostico = () => {
    try {
        return JSON.parse(
            localStorage.getItem("info") || "null"
        )?.ID_REGIONAL_ACTUAL ?? null;
    } catch {
        return null;
    }
};

const enviarMarcacion = async (sucursal) => {
    if (!ubicacionActual && sucursal.tipo !== 'EX') {
      if (esUbicacionAproximada) {
        return alert("❌ Se detectó permiso de ubicación aproximada. Por favor activa la 'Ubicación precisa' en los permisos de tu navegador.");
      }
      return alert("Esperando señal de GPS precisa...");
    }
    
    try {
        const idEmpleado = ReactSession.get("idSession");
        const cargoEmpleado = ReactSession.get("cargo");
        const idModulo = 145; 
        const codigoMarca = tipoMarca === "INGRESO" ? "I" : "S";
        var observacionesAEnviar = `Marcado web en ${sucursal.nombre}`

        if(sucursal.tipo === 'EX' ){
          let texto = 'Se marcó la salida';
          if(codigoMarca === 'I'){
              texto = '';
              texto = await pedirTexto();
          }
          if (!texto || texto.trim() === "") {
              alert(
                  `❌ El texto no puede estar vacio. Intente nuevamente.`
              );
              return;
            }
            observacionesAEnviar = texto.trim(); 
        }

        setLoading(true);

        const response = await fetch(
              `${server}/api/asistencia/marcar`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  idEmpleado,
                  cargoEmpleado,
                  idSucursal: sucursal.id,
                  tipo: codigoMarca,
                  sucursalTipo: sucursal.tipo,
                  latUsuario: sucursal.tipo === "EX"
                    ? null
                    : ubicacionActual.lat,
                  lngUsuario: sucursal.tipo === "EX"
                    ? null
                    : ubicacionActual.lng,
                  observaciones: observacionesAEnviar,
                  observacionesSeguimiento: sucursal.tipo === "EX"
                    ? "EXTERNO"
                    : `${ubicacionActual.lat},${ubicacionActual.lng}${ubicacionActual.accuracy != null ? `,acc:${Math.round(ubicacionActual.accuracy)}m` : ''}`,
                  idModulo,
                  ipservidor: sucursal.servidor,
                  idregional: Number(
                      JSON.parse(localStorage.getItem("info"))
                          .ID_REGIONAL_ACTUAL
                  ),
              })
            });   
      
      if (!response.ok) {
          throw new Error(
              `Error HTTP ${response.status} al enviar marcación`
          );
      }

      const data = await response.json();

     if (data.success !== true) {

          guardarErrorAsistencia({
              accion: "VALIDACION_MARCACION",
              error: new Error(
                  data.mensaje || "El servidor rechazó la marcación sin mensaje"
              ),
              tipo: "VALIDACION",
              idEmpleado: ReactSession.get("idSession"),
              idSucursal: sucursal?.id,
              idRegional: obtenerRegionalDiagnostico(),
              detalles: {
                  tipoMarca,
                  endpoint: "/api/asistencia/marcar",
                  precisionGPS: precisionGPS ?? ubicacionActual?.accuracy ?? null,
                  esUbicacionAproximada
              }
          });

          alert(
              "❌ " +
              (data.mensaje || "No se pudo registrar la marcación.")
          );

          return;
      }


      if (data.requiereCodigo) {
          setProcesoMarcacion({
              idProceso: data.idProceso,
              sucursal
          });

          console.log("RESPUESTA DEL BACKEND AL MARCAR:", {
              observacionSalidaAnticipada: data.observacionSalidaAnticipada,
              esItinerario: data.esItinerario,
              destinoConfigurado: data.destinoConfigurado,
              siguienteDestino: data.siguienteDestino,
              codigoMarca
          });

          setCodigoConfirmacion("");
          setDestinoSeleccionado("");
          setSucursalDestinoSeleccionada("");
          setObservacionSalidaAnticipada("");
          setDestinoConfigurado(false);
          setSiguienteDestino(null);
          setMostrarDestino(false);
          setInsertarObservacion(false);

          const esSalidaAnticipada =
              data.observacionSalidaAnticipada === true &&
              codigoMarca === "S";

          const esItinerario = data.esItinerario === true;

          const hayDestinoConfigurado =
              data.destinoConfigurado === true &&
              data.siguienteDestino != null;

          console.log("CONDICIONES PARA MOSTRAR OPCIONES:", {
              esSalidaAnticipada,
              esItinerario,
              hayDestinoConfigurado,
              mostrarOpciones:
                  esSalidaAnticipada &&
                  esItinerario &&
                  !hayDestinoConfigurado
          });

          if (esSalidaAnticipada) {
              if (esItinerario) {
                  if (hayDestinoConfigurado) {
                      setDestinoConfigurado(true);
                      setSiguienteDestino(data.siguienteDestino);
                  } else {
                      setMostrarDestino(true);
                  }
              } else {
                  setInsertarObservacion(true);
              }
          }

          setMostrarCodigo(true);
          return;
      }
    }catch (error) {

        console.error("Error en enviarMarcacion:", error);

        guardarErrorAsistencia({
            accion: "ENVIAR_MARCACION",
            error,
            tipo: error?.name === "AbortError" ||
                  error?.name === "TimeoutError"
                      ? "TIMEOUT"
                      : error instanceof TypeError &&
                      /fetch|network/i.test(error.message)
                          ? "CONEXION"
                          : "TECNICO",
            idEmpleado: ReactSession.get("idSession"),
            idSucursal: sucursal?.id,
            idRegional: obtenerRegionalDiagnostico(),
            detalles: {
                tipoMarca,
                endpoint: "/api/asistencia/marcar"
            }
        });

        alert(
            "Ocurrió un error al registrar la asistencia. " +
            "Verifique su conexión e intente nuevamente."
        );

    } finally {
        setLoading(false);
    }
  };

  const confirmarMarcacion = async () => {
     
    if (confirmandoRef.current) return;
    try {


        // =====================================
        // VALIDAR SIGUIENTE DESTINO
        // =====================================

        if (
            mostrarDestino &&
            !destinoConfigurado &&
            destinoSeleccionado === ""
        ) {

            alert(
                "❌ Debe seleccionar su siguiente destino."
            );

            return;
        }

        if (
          destinoSeleccionado === "SUCURSAL" &&
          !destinoConfigurado &&
          sucursalDestinoSeleccionada === ""
      ) {
          alert(
              "❌ Debe seleccionar la sucursal u oficina de destino."
          );

          return;
      }


        // =====================================
        // VALIDAR JUSTIFICACIÓN
        // =====================================

        if (
            insertarObservacion &&
            observacionSalidaAntipada.trim() === ""
        ) {

            alert(
                "❌ Debe indicar el motivo de la salida anticipada."
            );

            return;
        }

          // Bloquear inmediatamente nuevas confirmaciones
          confirmandoRef.current = true;
          setConfirmandoMarcacion(true);
          
          const response = await fetch(
              `${server}/api/asistencia/confirmar-marcacion`,
              {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json'
                  },
                   body: JSON.stringify({
                      idProceso:
                          procesoMarcacion.idProceso,

                      codigo:
                          codigoConfirmacion,

                      tipoSiguienteDestino:
                          destinoConfigurado
                              ? "CONFIGURADO"
                              : destinoSeleccionado,

                      idSiguienteDestino:
                          destinoConfigurado &&
                          siguienteDestino
                              ? siguienteDestino.idSucursal

                              : destinoSeleccionado === "SUCURSAL"
                                  ? Number(sucursalDestinoSeleccionada)

                                  : null,

                      observacionSalidaAnticipada:
                          insertarObservacion
                              ? observacionSalidaAntipada.trim()
                              : null
                  })
              }
          );

          if (!response.ok) {
              throw new Error(
                  `Error HTTP ${response.status} al confirmar la marcación`
              );
          }

          const data = await response.json();

          if (!data.success) {
            guardarErrorAsistencia({
                accion: "VALIDACION_CONFIRMACION",
                error: new Error(
                    data.mensaje || "Confirmación rechazada"
                ),
                tipo: "VALIDACION",
                idEmpleado: ReactSession.get("idSession"),
                idSucursal: procesoMarcacion?.sucursal?.id ?? null,
                idRegional: obtenerRegionalDiagnostico(),
                detalles: {
                    tipoMarca,
                    endpoint: "/api/asistencia/confirmar-marcacion",
                    codigoIncorrecto: data.codigoIncorrecto === true
                }
            });

            if (data.codigoIncorrecto) {

                const nuevosIntentos = intentos - 1;
                setIntentos(nuevosIntentos);
                if (nuevosIntentos <= 0) {
                    alert(
                        "❌ PIN incorrecto. No se pudo registrar la asistencia."
                    );
                    setMostrarCodigo(false);
                    setCodigoConfirmacion("");
                    setProcesoMarcacion(null);
                    setIntentos(3);
                    setModo("principal");
                    return;
                }
                alert(
                    `❌ PIN incorrecto. Intente nuevamente.\n` +
                    `Te quedan ${nuevosIntentos} intento(s).`
                );
                setCodigoConfirmacion("");
                setMostrarCodigo(true);
                return;
            }
            alert(`❌ ${data.mensaje}`);
            return;
          }

          let mensajeAtraso = "";

          if (data.atraso > 0) {
              mensajeAtraso =
                  `\n⚠️ Atraso de Hoy: ${data.atraso} minutos`;
          } else {
              mensajeAtraso =
                  `\n✨ Puntual o sin atraso hoy`;
          }

          let mensajeAtrasoAcumulado = "";

          if (data.minutosacumulados > 0) {
              mensajeAtrasoAcumulado =
                  `\n⚠️ Atrasos acumulados: ${data.minutosacumulados} minutos`;
          } else {
              mensajeAtrasoAcumulado =
                  `\n✨ Sin atrasos acumulados`;
          }

          alert(
              `✅ Registro exitoso\n` +
              `Observaciones: ${data.mensaje}\n` +
              `Hora Servidor: ${data.hora}` +
              mensajeAtraso +
              mensajeAtrasoAcumulado
          );

          setMostrarCodigo(false);
          setCodigoConfirmacion("");
          setProcesoMarcacion(null);

          setModo("principal");

      }  catch (error) {

        console.error("Error en confirmarMarcacion:", error);

        guardarErrorAsistencia({
            accion: "CONFIRMAR_MARCACION",
            error,
           tipo: error?.name === "AbortError" ||
                 error?.name === "TimeoutError"
                     ? "TIMEOUT"
                     : error instanceof TypeError &&
                     /fetch|network/i.test(error.message)
                         ? "CONEXION"
                         : "TECNICO",
            idEmpleado: ReactSession.get("idSession"),
            idSucursal: procesoMarcacion?.sucursal?.id,
            idRegional: obtenerRegionalDiagnostico(),
            detalles: {
                tipoMarca,
                endpoint: "/api/asistencia/confirmar-marcacion"
            }
        });

        alert(
            "Ocurrió un error al confirmar la asistencia. " +
            "Verifique su conexión e intente nuevamente."
        );
      }
      finally {

        // Desbloquear al recibir respuesta o producirse un error
        confirmandoRef.current = false;
        setConfirmandoMarcacion(false);

    }
  };

    useEffect(() => {
        activarDiagnosticosJavaScript();
    }, []);


  // --- RENDERIZADO ---
 /* if (cargando) {
    return <div style={{display:'flex', justifyContent:'center', alignItems:'center', height:'100vh'}}>Sincronizando con el servidor...</div>;
  }*/

  // Estilos (se mantienen los tuyos)
  const styles = {
    layout: { height: "94vh", backgroundColor: "#9b9b9b", fontFamily: "'Segoe UI', sans-serif", display: "flex", flexDirection: "column", overflow: "hidden" },
    container: { flex: 1, padding: "20px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" },
    horaBig: { fontSize: "55px", fontWeight: "700", color: "#000", marginBottom: "5px" },
    sucursalCard: (cerca) => ({
      backgroundColor: "#fff", padding: "12px", borderRadius: "12px", display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px",
      borderLeft: cerca ? "6px solid #28a745" : "6px solid #dc3545", opacity: cerca ? 1 : 0.8, cursor: cerca ? "pointer" : "not-allowed", boxShadow: "0 2px 5px rgba(0,0,0,0.1)"
    }),
    btnBig: { height: "150px", width: "100%", maxWidth: "200px", borderRadius: "20px", border: "none", backgroundColor: "#fff", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", cursor: "pointer" }
  };

  const formatearHora = (f) => f.toLocaleTimeString("es-BO", { hour12: false });
  const formatearFecha = (f) => f.toLocaleDateString("es-BO", { weekday: "long", day: "2-digit", month: "long", year: "numeric" });

  if (modo === "sucursales") {
    return (
      <div style={styles.layout}>
        <div style={{ backgroundColor: tipoMarca === "INGRESO" ? "#007bff" : "#ff4500", padding: "15px", color: "white", textAlign: "center", fontWeight: "bold" }}>
          <span style={{ float: "left", cursor: "pointer" }} onClick={() => setModo("principal")}>⬅ Volver</span>
          MARCAR {tipoMarca}
        </div>
        <main style={{ ...styles.container, justifyContent: "flex-start", overflowY: "auto" }}>
          <div style={{ ...styles.horaBig, fontSize: "40px", marginTop: "20px" }}>{formatearHora(hora)}</div>
          <p style={{ color: "#333", fontSize: "13px", marginBottom: "10px" }}>Selecciona sucursal (Rango: 30m)</p>

          {precisionGPS !== null && !esUbicacionAproximada && (
            <div style={{
              fontSize: "12px",
              color: precisionGPS <= 30 ? "#155724" : precisionGPS <= 60 ? "#856404" : "#721c24",
              backgroundColor: precisionGPS <= 30 ? "#d4edda" : precisionGPS <= 60 ? "#fff3cd" : "#f8d7da",
              border: `1px solid ${precisionGPS <= 30 ? "#c3e6cb" : precisionGPS <= 60 ? "#ffeeba" : "#f5c6cb"}`,
              padding: "4px 12px",
              borderRadius: "20px",
              marginBottom: "12px",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              fontWeight: "500"
            }}>
              <span>
                  📍 Precisión GPS: ±{Math.round(precisionGPS)}m
              </span>
              <span>${precisionGPS <= 30 ? "✓ (Óptima)" : precisionGPS <= 60 ? "✓ (Aceptable)" : "⏳ (Estabilizando...)"}</span>
            </div>
          )}

          {esUbicacionAproximada && (
            <div style={{
              backgroundColor: "#fff3cd",
              border: "1px solid #ffeeba",
              color: "#856404",
              padding: "16px",
              borderRadius: "12px",
              marginBottom: "15px",
              maxWidth: "450px",
              width: "100%",
              boxSizing: "border-box",
              textAlign: "left",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
            }}>
              <div style={{ fontWeight: "bold", fontSize: "14px", marginBottom: "8px", display: "flex", alignItems: "center", gap: "6px" }}>
                <span>⚠️</span> Permiso de ubicación aproximada detectado
              </div>
              <p style={{ fontSize: "12px", margin: "0 0 10px 0", lineHeight: "1.4" }}>
                  Tu dispositivo está entregando una ubicación aproximada{" "}
                  {precisionGPS
                      ? `(margen de ±${Math.round(precisionGPS)}m)`
                      : "(varios kilómetros de margen)"}. Para registrar asistencia en la sucursal, se requiere{" "}
                  <strong>Ubicación Precisa</strong>.
              </p>
              <div style={{ fontSize: "12px", backgroundColor: "#fff", padding: "10px", borderRadius: "8px", border: "1px solid #fae8a4" }}>
                <strong>¿Cómo activar la ubicación precisa?</strong>
                <ul style={{ margin: "6px 0 0 0", paddingLeft: "18px", lineHeight: "1.5" }}>
                  <li><strong>En Android (Chrome):</strong> Toca el ícono a la izquierda de la dirección URL (candado o ajustes) &gt; <em>Permisos</em> &gt; <em>Ubicación</em> &gt; activa <strong>"Usar ubicación precisa"</strong>.</li>
                  <li><strong>En iPhone (Safari):</strong> Ve a <em>Ajustes</em> de tu iPhone &gt; <em>Privacidad y seguridad</em> &gt; <em>Localización</em> &gt; <em>Sitios web de Safari</em> &gt; activa <strong>"Ubicación precisa"</strong>.</li>
                </ul>
              </div>
            </div>
          )}

          {mensajeError && <div style={{ backgroundColor: "#ffdee0", color: "#d32f2f", padding: "10px", borderRadius: "8px", marginBottom: "15px", maxWidth: "450px", width: "100%", boxSizing: "border-box" }}>{mensajeError}</div>}

          <div style={{ width: "100%", maxWidth: "450px" }}>
            {sucursalesCalculadas.map((suc) => (
              <div key={suc.id} style={styles.sucursalCard(suc.estaCerca || suc.tipo === "EX")} onClick={() => (suc.estaCerca || suc.tipo === "EX") && enviarMarcacion(suc)}>
                <div>
                  <div style={{ fontWeight: "bold", fontSize: "14px" }}>{suc.nombre}</div>
                  {/*<div style={{ fontSize: "11px", color: suc.estaCerca ? "#28a745" : "#666" }}>
                    {suc.estaCerca ? "● Estás en el sitio" : "● Fuera de rango"}
                  </div>*/}

                  <div
                    style={{
                      fontSize: "11px",
                      color:
                        suc.tipo === "EX"
                          ? "#007bff"
                          : suc.estaCerca
                            ? "#28a745"
                            : "#666"
                    }}
                  >
                    {suc.tipo === "EX"
                      ? "● Lugar externo"
                      : suc.estaCerca
                        ? "● Estás en el sitio"
                        : "● Fuera de rango"}
                  </div>

                </div>
                {/*<div style={{ backgroundColor: suc.estaCerca ? "#28a745" : "#666", color: "white", padding: "5px 10px", borderRadius: "6px", fontSize: "12px", fontWeight: "bold" }}>
                  {suc.distanciaTexto || "---"}
                </div>*/}

                <div
                  style={{
                    backgroundColor:
                      suc.tipo === "EX"
                        ? "#007bff"
                        : suc.estaCerca
                          ? "#28a745"
                          : "#666",
                    color: "white",
                    padding: "5px 10px",
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontWeight: "bold"
                  }}
                >
                  {suc.tipo === "EX"
                    ? "EXTERNO"
                    : suc.distanciaTexto || "---"}
                </div>
              </div>
            ))}
          </div>
        </main>
           {mostrarDialogo && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
              padding: "20px",
              boxSizing: "border-box"
            }}
          >

            <div
              style={{
                backgroundColor: "white",
                borderRadius: "15px",
                padding: "20px",
                width: "100%",
                maxWidth: "500px",
                boxSizing: "border-box",
                boxShadow: "0 5px 20px rgba(0,0,0,0.3)"
              }}
            >

              <h3 style={{ marginTop: 0 }}>
                ¿Dónde estás marcando?
              </h3>

              <p style={{ color: "#555" }}>
                Por favor describe el lugar donde marcas asistencia
              </p>

            <textarea
                value={textoDialogo}
                onChange={(e) => setTextoDialogo(e.target.value)}
                placeholder="Escriba aquí la observación..."
                rows={10}
                autoFocus
                style={{
                  width: "100%",
                  resize: "vertical",
                  boxSizing: "border-box",
                  padding: "10px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  fontFamily: "inherit",
                  fontSize: "14px",
                  outline: "none"
                }}
              />

              

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  marginTop: "15px"
                }}
              >

                <button
                      onClick={() => {
                          setMostrarDialogo(false);

                          if (resolverDialogo) {
                              resolverDialogo("");
                          }
                      }}
                  style={{
                    padding: "10px 20px",
                    border: "none",
                    borderRadius: "8px",
                    backgroundColor: "#777",
                    color: "white",
                    cursor: "pointer"
                  }}
                >
                  Cancelar
                </button>

                <button
                    onClick={() => {
                          setMostrarDialogo(false);

                          if (resolverDialogo) {
                              resolverDialogo(textoDialogo);
                          }
                      }}
                  style={{
                    padding: "10px 20px",
                    border: "none",
                    borderRadius: "8px",
                    backgroundColor:
                      tipoMarca === "INGRESO"
                        ? "#007bff"
                        : "#ff4500",
                    color: "white",
                    cursor: "pointer",
                    fontWeight: "bold"
                  }}
                >
                  Enviar
                </button>

              </div>

            </div>

          </div>
        )}
        {mostrarCodigo && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 10000,
                        padding: "20px",
                        boxSizing: "border-box"
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            borderRadius: "15px",
                            padding: "25px",
                            width: "100%",
                            maxWidth: "400px",
                            boxSizing: "border-box",
                            boxShadow: "0 5px 20px rgba(0,0,0,0.3)",

                            // Para que nunca salga de la pantalla
                            maxHeight: "90vh",
                            overflowY: "auto"
                        }}
                    >
                        <h3
                            style={{
                                marginTop: 0,
                                marginBottom: "20px",
                                textAlign: "center"
                            }}
                        >
                            Confirmar marcación
                        </h3>
                  {destinoConfigurado && siguienteDestino && (
                      <div
                          style={{
                              backgroundColor: "#e8f5e9",
                              border: "1px solid #28a745",
                              borderRadius: "8px",
                              padding: "14px",
                              marginBottom: "20px",
                              textAlign: "center"
                          }}
                      >
                          <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
                              Siguiente parada:
                          </div>

                          <div style={{ fontSize: "16px" }}>
                              {siguienteDestino.sucursal}
                          </div>

                          <small style={{ color: "#555" }}>
                              Destino definido por tu itinerario.
                          </small>
                      </div>
                  )}


                      {mostrarDestino && (
                          <div style={{ marginBottom: "20px" }}>

                              <div
                                  style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "10px"
                                  }}
                              >

                                  {/* ============================== */}
                                  {/* OTRA SUCURSAL / OFICINA       */}
                                  {/* ============================== */}

                                  <button
                                      type="button"
                                      disabled={destinoConfigurado}
                                      onClick={() => {

                                          if (destinoConfigurado) return;

                                          setDestinoSeleccionado("SUCURSAL");

                                          setInsertarObservacion(false);

                                          setObservacionSalidaAnticipada("");
                                      }}
                                      style={{
                                          padding: "15px",
                                          borderRadius: "10px",

                                          border:
                                              destinoSeleccionado === "SUCURSAL"
                                                  ? "2px solid #007bff"
                                                  : "1px solid #ccc",

                                          backgroundColor:
                                              destinoSeleccionado === "SUCURSAL"
                                                  ? "#e7f1ff"
                                                  : "#fff",

                                          cursor:
                                              destinoConfigurado
                                                  ? "not-allowed"
                                                  : "pointer",

                                          opacity:
                                              destinoConfigurado
                                                  ? 0.6
                                                  : 1,

                                          textAlign: "left"
                                      }}
                                  >

                                      <div
                                          style={{
                                              fontWeight: "bold",
                                              fontSize: "15px"
                                          }}
                                      >
                                          🏢 Otra sucursal / oficina
                                      </div>

                                      <div
                                          style={{
                                              fontSize: "12px",
                                              color: "#666",
                                              marginTop: "3px"
                                          }}
                                      >
                                          Continuaré mi jornada en otra sucursal.
                                      </div>

                                      <div
                                          style={{
                                              fontSize: "12px",
                                              color: "red",
                                              fontWeight: "bold",
                                              marginTop: "6px"
                                          }}
                                      >
                                          ⚠️ Advertencia: Se asignará un nuevo itinerario en la sucursal seleccionada.
                                      </div>

                                  </button>


                                  {/* ============================== */}
                                  {/* LUGAR EXTERNO                 */}
                                  {/* ============================== */}

                                  <button
                                      type="button"
                                      disabled={destinoConfigurado}
                                      onClick={() => {

                                          if (destinoConfigurado) return;

                                              setDestinoSeleccionado("EXTERNO");

                                              setSucursalDestinoSeleccionada("");

                                              setInsertarObservacion(false);

                                              setObservacionSalidaAnticipada("");
                                      }}
                                      style={{
                                          padding: "15px",
                                          borderRadius: "10px",

                                          border:
                                              destinoSeleccionado === "EXTERNO"
                                                  ? "2px solid #007bff"
                                                  : "1px solid #ccc",

                                          backgroundColor:
                                              destinoSeleccionado === "EXTERNO"
                                                  ? "#e7f1ff"
                                                  : "#fff",

                                          cursor:
                                              destinoConfigurado
                                                  ? "not-allowed"
                                                  : "pointer",

                                          opacity:
                                              destinoConfigurado
                                                  ? 0.6
                                                  : 1,

                                          textAlign: "left"
                                      }}
                                  >

                                      <div
                                          style={{
                                              fontWeight: "bold",
                                              fontSize: "15px"
                                          }}
                                      >
                                          📍 Lugar externo
                                      </div>

                                      <div
                                          style={{
                                              fontSize: "12px",
                                              color: "#666",
                                              marginTop: "3px"
                                          }}
                                      >
                                          Continuaré mi jornada fuera de una sucursal.
                                      </div>

                                  </button>


                                  {/* ============================== */}
                                  {/* FIN DE TURNO                  */}
                                  {/* ============================== */}

                                  <button
                                      type="button"
                                      //disabled={destinoConfigurado}
                                      onClick={() => {

                                          if (destinoConfigurado) return;

                                          
                                            setDestinoSeleccionado("FIN");

                                            setSucursalDestinoSeleccionada("");

                                            setInsertarObservacion(true);
                                      }}
                                      style={{
                                          padding: "15px",
                                          borderRadius: "10px",

                                          border:
                                              destinoSeleccionado === "FIN"
                                                  ? "2px solid #dc3545"
                                                  : "1px solid #ccc",

                                          backgroundColor:
                                              destinoSeleccionado === "FIN"
                                                  ? "#fdeaea"
                                                  : "#fff",

                                          cursor:
                                              destinoConfigurado
                                                  ? "not-allowed"
                                                  : "pointer",

                                          opacity:
                                              destinoConfigurado
                                                  ? 0.6
                                                  : 1,

                                          textAlign: "left"
                                      }}
                                  >

                                      <div
                                          style={{
                                              fontWeight: "bold",
                                              fontSize: "15px"
                                          }}
                                      >
                                          🏁 Fin de turno
                                      </div>

                                      <div
                                          style={{
                                              fontSize: "12px",
                                              color: "#666",
                                              marginTop: "3px"
                                          }}
                                      >
                                          No continuaré mi jornada en otro lugar.
                                      </div>

                                  </button>

                              </div>

                          </div>
                      )}

                      {destinoSeleccionado === "SUCURSAL" &&
                          !destinoConfigurado && (

                          <div
                              style={{
                                  marginTop: "15px"
                              }}
                          >

                              <label
                                  style={{
                                      display: "block",
                                      fontWeight: "bold",
                                      marginBottom: "6px"
                                  }}
                              >
                                  Seleccione la sucursal u oficina
                              </label>

                              <select
                                  className="form-select"
                                  value={sucursalDestinoSeleccionada}
                                  onChange={(e) =>
                                      setSucursalDestinoSeleccionada(
                                          e.target.value
                                      )
                                  }
                              >

                                  <option value="">
                                      Seleccione...
                                  </option>

                                  {sucursalesBase
                                      .filter(s =>
                                          s.tipo !== "EX" &&
                                          String(s.id) !==
                                          String(procesoMarcacion?.sucursal?.id)
                                      )
                                      .map((s) => (

                                          <option
                                              key={s.id}
                                              value={s.id}
                                          >
                                              {s.nombre}
                                          </option>

                                      ))
                                  }

                              </select>

                          </div>
                      )}

                        {/* OBSERVACIÓN SOLO SI ES SALIDA ANTICIPADA */}
                        {insertarObservacion && (
                            <div style={{ marginBottom: "20px" }}>
                                <p
                                    style={{
                                        color: "#555",
                                        marginBottom: "8px"
                                    }}
                                >
                                    Está saliendo antes de su horario.
                                    Indique el motivo:
                                </p>

                                <textarea
                                    value={observacionSalidaAntipada}
                                    onChange={(e) =>
                                        setObservacionSalidaAnticipada(
                                            e.target.value
                                        )
                                    }
                                    placeholder="Motivo de salida anticipada..."
                                    rows={4}
                                    autoFocus
                                    style={{
                                        width: "100%",
                                        boxSizing: "border-box",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                        fontFamily: "inherit",
                                        fontSize: "14px",
                                        resize: "vertical",
                                        outline: "none"
                                    }}
                                />
                            </div>
                        )}

                        {/* CÓDIGO DE CONFIRMACIÓN */}
                        <p
                            style={{
                                color: "#555",
                                textAlign: "center",
                                marginBottom: "10px"
                            }}
                        >
                            Ingrese el código de confirmación
                        </p>

                        <input
                            type="password"
                            inputMode="numeric"
                            value={codigoConfirmacion}
                            onChange={(e) =>
                                setCodigoConfirmacion(e.target.value)
                            }
                            placeholder="Código"
                            autoFocus={!insertarObservacion}
                            style={{
                                width: "100%",
                                boxSizing: "border-box",
                                padding: "12px",
                                borderRadius: "8px",
                                border: "1px solid #ccc",
                                fontSize: "18px",
                                textAlign: "center",
                                outline: "none"
                            }}
                        />

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "10px",
                                marginTop: "20px",

                                position: "sticky",
                                bottom: "-25px",
                                backgroundColor: "white",
                                paddingTop: "15px",
                                paddingBottom: "20px",
                                zIndex: 10,
                                borderTop: "1px solid #eee"
                            }}
                        >
                            <button
                                disabled={confirmandoMarcacion}
                                onClick={() => {
                                    setMostrarCodigo(false);
                                    setCodigoConfirmacion("");
                                    setProcesoMarcacion(null);
                                    setInsertarObservacion(false);
                                    setObservacionSalidaAnticipada("");
                                }}
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "8px",
                                    backgroundColor: "#777",
                                    color: "white",
                                    cursor: "pointer"
                                }}
                            >
                                Cancelar
                            </button>

                            <button
                                type="button"
                                onClick={confirmarMarcacion}
                                disabled={confirmandoMarcacion}
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "8px",
                                    backgroundColor: confirmandoMarcacion
                                        ? "#999"
                                        : tipoMarca === "INGRESO"
                                            ? "#007bff"
                                            : "#ff4500",
                                    color: "white",
                                    cursor: confirmandoMarcacion
                                        ? "not-allowed"
                                        : "pointer",
                                    fontWeight: "bold",
                                    opacity: confirmandoMarcacion ? 0.7 : 1
                                }}
                            >
                                {confirmandoMarcacion
                                    ? "Confirmando..."
                                    : "Confirmar"}
                            </button>
                        </div>
                    </div>
                </div>
            )
        
        
        /**mostrarCodigo && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10000,
                padding: "20px",
                boxSizing: "border-box"
              }}
            >
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "15px",
                  padding: "25px",
                  width: "100%",
                  maxWidth: "400px",
                  boxSizing: "border-box",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.3)"
                }}
              >

                <h3
                  style={{
                    marginTop: 0,
                    marginBottom: "10px",
                    textAlign: "center"
                  }}
                >
                  Confirmar marcación
                </h3>

                <p
                  style={{
                    color: "#555",
                    textAlign: "center",
                    marginBottom: "20px"
                  }}
                >
                  Ingrese el código de confirmación
                </p>

                <input
                  type="number"
                  value={codigoConfirmacion}
                  onChange={(e) => setCodigoConfirmacion(e.target.value)}
                  placeholder="Código"
                  autoFocus
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    padding: "12px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                    fontSize: "18px",
                    textAlign: "center",
                    outline: "none"
                  }}
                />

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                    marginTop: "20px"
                  }}
                >

                  <button
                    onClick={() => {
                      setMostrarCodigo(false);
                      setCodigoConfirmacion("");
                      setProcesoMarcacion(null);
                    }}
                    style={{
                      padding: "10px 20px",
                      border: "none",
                      borderRadius: "8px",
                      backgroundColor: "#777",
                      color: "white",
                      cursor: "pointer"
                    }}
                  >
                    Cancelar
                  </button>

                  <button
                    onClick={confirmarMarcacion}
                    style={{
                      padding: "10px 20px",
                      border: "none",
                      borderRadius: "8px",
                      backgroundColor:
                        tipoMarca === "INGRESO"
                          ? "#007bff"
                          : "#ff4500",
                      color: "white",
                      cursor: "pointer",
                      fontWeight: "bold"
                    }}
                  >
                    Confirmar
                  </button>

                </div>
              </div>
            </div>
          )*/}
      </div>
    );
  }

  return (
    <div style={styles.layout}>
      <main style={styles.container}>
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <div style={{ color: "#000", fontSize: "18px", textTransform: "uppercase" }}>{formatearFecha(hora)}</div>
          <div style={styles.horaBig}>{formatearHora(hora)}</div>
          <p style={{ color: "#444", fontSize: "14px" }}>Hora oficial del servidor</p>
        </div>
        <h3 style={{ color: "#000", marginBottom: "30px", fontWeight: "400" }}>¿Qué desea registrar hoy?</h3>
        <div style={{ display: "flex", gap: "20px", width: "100%", justifyContent: "center" }}>
          <button style={{ ...styles.btnBig, color: "#007bff" }} onClick={() => { setTipoMarca("INGRESO"); setModo("sucursales"); }}>
            <span style={{ fontWeight: "bold" }}>INGRESO</span>
          </button>
          <button style={{ ...styles.btnBig, color: "#ff4500" }} onClick={() => { setTipoMarca("SALIDA"); setModo("sucursales"); }}>
            <span style={{ fontWeight: "bold" }}>SALIDA</span>
          </button>
        </div>
      </main>
    </div>
  );
}